import update from 'immutability-helper';
import * as types from './types';

const initialState = {
  isFetching: true,
};

const switchMap = {};

switchMap[types.INIT] = state => update(state, {
  $set: initialState,
});

switchMap[types.START_FETCHING] = state => update(state, {
  isFetching: {
    $set: true,
  },
});

switchMap[types.END_FETCHING] = state => update(state, {
  isFetching: {
    $set: false,
  },
});

export default (state = initialState, action) => (
  switchMap[action.type]
    ? switchMap[action.type](state, action)
    : state
);
